export enum ModalKeyEnum {
  CAUTION = "CAUTION",
  FAIRNESS = "FAIRNESS",
  VERIFICATION = "VERIFICATION",
  CAMERA_PERMISSION = "CAMERA_PERMISSION",
  OPTIONAL_FORM = "OPTIONAL_FORM",
  LIVENESS_START = "LIVENESS_START",
  AFTER_FORM_START = "AFTER_FORM_START",
  VERIFICATION_SUCCESS = "VERIFICATION_SUCCESS",
  VERIFICATION_FAILED = "VERIFICATION_FAILED",
}
